/* eslint-disable react-hooks/exhaustive-deps */
import React, { createContext, ReactNode, useContext, useEffect, useState } from "react";

export interface PageLink {
  title: string;
  path: string;
  isActive: boolean;
}

export interface PageDataContextModel {
  moduleName?: string;
  setModuleName: (_moduleName: string) => void;
  pageTitle?: string;
  setPageTitle: (_title: string) => void;
  pageDescription?: string;
  setPageDescription: (_description: string) => void;
  pageBreadcrumbs?: Array<PageLink>;
  setPageBreadcrumbs: (_breadcrumbs: Array<PageLink>) => void;
  pageSubmenu?: Array<PageLink>;
  setPageSubmenu: (_submenu: Array<PageLink>) => void;
}

const PageDataContext = createContext<PageDataContextModel>({
  setModuleName: (_moduleName: string) => {},
  setPageSubmenu: (_submenu: Array<PageLink>) => {},
  setPageTitle: (_title: string) => {},
  setPageBreadcrumbs: (_breadcrumbs: Array<PageLink>) => {},
  setPageDescription: (_description: string) => {},
});

type PageDataProviderPropsType = {
  children: ReactNode;
};

const PageDataProvider: React.FC<PageDataProviderPropsType> = (props: PageDataProviderPropsType) => {
  const [moduleName, setModuleName] = useState<string>("");
  const [pageTitle, setPageTitle] = useState<string>("");
  const [pageDescription, setPageDescription] = useState<string>("");
  const [pageBreadcrumbs, setPageBreadcrumbs] = useState<Array<PageLink>>([]);
  const [pageSubmenu, setPageSubmenu] = useState<Array<PageLink>>([]);
  const value: PageDataContextModel = {
    moduleName,
    setModuleName,
    pageTitle,
    setPageTitle,
    pageDescription,
    setPageDescription,
    pageBreadcrumbs,
    setPageBreadcrumbs,
    pageSubmenu,
    setPageSubmenu,
  };
  return (
    <PageDataContext.Provider value={value}>
      {props.children}
    </PageDataContext.Provider>
  );
};

function usePageData() {
  return useContext(PageDataContext);
}

type Props = {
  title?: string;
  description?: string;
  submenu?: Array<PageLink>;
  breadcrumbs?: Array<PageLink>;
  children?: Array<PageLink>;
};

type childrenProps = {
  children: string;
};

const PageDataContainer: React.FC<Props> = ({
  submenu,
  breadcrumbs,
  children,
}) => {
  const { setPageBreadcrumbs, setPageSubmenu } = usePageData();

  useEffect(() => {
    if (breadcrumbs) {
      setPageBreadcrumbs(breadcrumbs);
    }

    if (submenu) {
      setPageSubmenu(submenu);
    }

    return () => {
      setPageBreadcrumbs(new Array<PageLink>());
      setPageSubmenu(new Array<PageLink>());
    };
  }, []);
  return <>{children}</>;
};



const PageTitle: React.FC<childrenProps> = (props: childrenProps) => {
  const { setPageTitle } = usePageData();
  useEffect(() => {
    if (props.children) {
      setPageTitle(props.children.toString());
    }
    return () => {
      setPageTitle("");
    };
  }, [props.children]);
  return <></>;
};

const PageDescription: React.FC<childrenProps> = (props: childrenProps) => {
  const { setPageDescription } = usePageData();
  useEffect(() => {
    if (props.children) {
      setPageDescription(props.children.toString());
    }
    return () => {
      setPageDescription("");
    };
  }, [props.children]);
  return <></>;
};


const ModuleName: React.FC<childrenProps> = (props: childrenProps) => {
  const { setModuleName } = usePageData();
  useEffect(() => {
    if (props.children) {
      setModuleName(props.children.toString());
    }
    return () => {
      setModuleName("");
    };
  }, [props.children]);
  return <></>;
};

export {
  ModuleName,
  PageDescription,
  PageTitle,
  PageDataContainer,
  PageDataProvider,
  usePageData,
};
